import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAmericanFootball: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="american-football, nfl"><path d="M13.25 3.25L20.75 10.75M3.25 13.25L10.75 20.75M10 14L14 10M14.75 2.75H19.25C20.3546 2.75 21.25 3.64543 21.25 4.75V9.25C21.25 15.8774 15.8774 21.25 9.25 21.25H4.75C3.64543 21.25 2.75 20.3546 2.75 19.25V14.75C2.75 8.12258 8.12258 2.75 14.75 2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconAmericanFootball;
